import { ArrowLeftColor } from "@components";
import { IMemberTier } from "@interfaces";
import { selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

interface IProps {
    socials: JSX.Element[];
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentCommunityEventDetail = (props: IProps) => {
    //page props
    const { socials } = props;
    const { t } = useTranslation();
    const merchant = useSelector(selectMerchant);
    const history = useHistory();
    const { themes } = useSelector(selectMerchant);

    return (
        <>
            <RenderMeta title={t("meta.communityeventdetail_page")} />
            <StyledCommunityEventDetail themeColor={themes?.themeColor!}>
                <div className="back-arrow">
                    <ArrowLeftColor color={themes?.themeColor} onClick={() => history.goBack()} />
                    {/* <span>{t("page.back")}</span> */}
                </div>
                {/* <div className="img-banner">
                    <span>
                        <img src="../images/img-badges-detail.png" alt="" />
                    </span>
                </div> */}
                <div className="layout-content-dialog">
                    <div className="main-content">
                        <div className="box-content">
                            <div className="title-content">ONCEs Camp ตอน MAKEUP ARTIST</div>
                            <div className="datetime-layout">
                                <div className="date">02/17</div> |{" "}
                                <div className="time">07:45-10:00</div>
                            </div>
                            <div className="detail-communitydetail">
                                <div className="person">49/50</div> |{" "}
                                <div className="location">Phrom Phong,Sukhumvit 24</div>
                            </div>
                            <div className="des-content-dialog">
                                <p>
                                    Register to purchase <span className="readmore">Read more</span>
                                </p>
                            </div>
                        </div>
                        <div className="box-content">
                            <div className="join-group-layout">
                                <div className="img-community-event">
                                    <img src="../images/join-group.png" alt="" />
                                </div>
                                <h2>Community Group</h2>
                                <div className="btn-join">
                                    <StyledUsedBtn
                                        className="btn-redeem"
                                        themeColor={themes?.themeColor!}
                                        // onClick={() => setOpenText(false)}
                                    >
                                        Join Group
                                    </StyledUsedBtn>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="btn-page">
                    <StyledMainJoin
                        className="btn-redeem"
                        themeColor={themes?.themeColor!}
                        // onClick={() => setOpenText(false)}
                    >
                        Join this event
                    </StyledMainJoin>
                </div>
            </StyledCommunityEventDetail>
        </>
    );
};

const StyledCommunityEventDetail = styled.div<{ themeColor: string }>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    background-color: #fff;
    background-position: right top;
    background-repeat: no-repeat;
    position: relative;
    background-image: url(../../images/img-community-event-detail-new.png);
    background-size: 100%;
    .btn-page {
        margin: 16px 0;
        position: fixed;
        bottom: 16px;
        left: 16px;
        width: calc(100% - 32px);
    }
    .layout-content-dialog {
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        background-color: #fff;
        padding: 0 0 280px;
        overflow: hidden;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        .top-content {
            width: 100%;
            padding: 16px 16px;
            background-color: #f3efeb;
            span {
                background-image: url(../../images/trophy.png);
                font-size: 18px;
                line-height: 21px;
                font-weight: 600;
                background-position: left center;
                background-repeat: no-repeat;
                padding-left: 30px;
            }
        }
        .main-content {
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            overflow: hidden;
            background: #fff;
            padding: 16px;
            .box-content {
                border-bottom: 1px solid #e1e1e1;
                margin: 0 0 16px;
                &:last-child {
                    border: none;
                }
                .join-group-layout {
                    position: relative;
                    height: 60px;
                    background-color: #f3f4f9;
                    border-radius: 12px;
                    overflow: hidden;
                    padding-left: 75px;
                    padding-right: 65px;
                    display: flex;
                    align-items: center;
                    .img-community-event {
                        position: absolute;
                        width: 42px;
                        height: 42px;
                        border-radius: 8px;
                        left: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    h2 {
                        font-size: 14px;
                        font-weight: 600;
                        color: #000;
                    }
                    .btn-join {
                        position: absolute;
                        right: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
                .datetime-layout {
                    display: flex;
                    margin-bottom: 12px;
                    gap: 5px;
                    align-items: center;
                    .date {
                        background-image: url(../../images/calendar-community.png);
                        background-position: left center;
                        background-repeat: no-repeat;
                        padding-left: 22px;
                        font-size: 16px;
                        color: #d2001f;
                        font-weight: 600;
                        align-items: center;
                    }
                    .time {
                        font-size: 14px;
                        color: #000;
                    }
                }
                .detail-communitydetail {
                    display: flex;
                    margin-bottom: 12px;
                    gap: 5px;
                    align-items: center;
                    .location {
                        color: #9b9b9b;
                        font-size: 10px;
                        background-image: url(../images/location-event.svg);
                        background-position: left center;
                        background-repeat: no-repeat;
                        background-size: 10px;
                        font-size: 12px;
                        color: #9b9b9b;
                        padding-left: 16px;
                    }
                    .person {
                        color: #9b9b9b;
                        background-image: url(../images/person-event.svg);
                        background-position: left center;
                        background-repeat: no-repeat;
                        background-size: 10px;
                        font-size: 12px;
                        padding-left: 16px;
                        color: #9b9b9b;
                    }
                }
                .des-content-dialog {
                    .title-des {
                        font-size: 14px;
                        font-weight: 600;
                        color: #000;
                        margin-bottom: 16px;
                        span.time {
                            float: right;
                            background-image: url(../../images/ic-time-dialog.svg);
                            background-position: left center;
                            background-repeat: no-repeat;
                            background-size: 16px;
                            padding-left: 20px;
                            color: #9b9b9b;
                        }
                    }
                }
                .img-badges-detail {
                    margin-bottom: 15px;
                    img {
                        width: 100%;
                    }
                }
                .herehow-title {
                    background-image: url(../../images/hand.svg);
                    font-size: 14px;
                    font-weight: 600;
                    background-position: left center;
                    background-repeat: no-repeat;
                    padding-left: 30px;
                    margin-bottom: 10px;
                }
                .title-content {
                    font-size: 18px;
                    color: #000;
                    font-weight: 600;
                    margin-bottom: 12px;
                    span {
                        float: right;
                        color: #3eba98;
                    }
                }
                p {
                    font-size: 14px;
                    line-height: 20px;
                    color: #525257;
                    margin-bottom: 12px;
                    span.readmore {
                        color: #ff0000;
                        font-weight: 600;
                    }
                }
                ol {
                    padding: 0;
                    list-style-position: inside;
                    li {
                        font-size: 14px;
                        color: #525257;
                        span.hashtag {
                            background-color: #fffad1;
                            color: #ad9a09;
                        }
                    }
                }
            }
        }
    }
    .img-banner {
        width: 100%;
        position: relative;
        padding-top: 75%;
        z-index: 0;
        span {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        top: 15px;
        display: flex;
        align-items: center;
        z-index: 1;
        span {
            margin-left: 10px;
            color: ${(p) => p.themeColor};
        }
    }
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
`;
const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 10px 12px;
    color: #000;
    background: #fff;
    border: 0.5px solid #e1e1e1;
    border-radius: 12px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;

const StyledMainJoin = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.theme.colors.card};
    // background: ${(p) => p.themeColor};
    background: linear-gradient(342deg, rgba(162, 26, 115, 1) 0%, rgba(227, 62, 59, 1) 100%);
    // border: 0.5px solid ${(p) => p.themeColor};
    border: none;
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    height: 48px;
    width: 100%;
    &:active {
        opacity: 0.8;
    }
`;
